export const Perm = {
  chatAccess: 'chat.access',
  projectsRead: 'chat.projects.read',
  projectsCreate: 'chat.projects.create',
  projectsUpdate: 'chat.projects.update',
  projectsDelete: 'chat.projects.delete',
  dashboardRead: 'organization_settings.dashboard.read',
  usersRead: 'organization_settings.users.read',
  usersCreate: 'organization_settings.users.create',
  usersUpdate: 'organization_settings.users.update',
  usersDelete: 'organization_settings.users.delete',
  rolesRead: 'organization_settings.roles.read',
  rolesCreate: 'organization_settings.roles.create',
  rolesUpdate: 'organization_settings.roles.update',
  rolesDelete: 'organization_settings.roles.delete',
  workspacesRead: 'organization_settings.workspaces.read',
  workspacesCreate: 'organization_settings.workspaces.create',
  workspacesUpdate: 'organization_settings.workspaces.update',
  workspacesDelete: 'organization_settings.workspaces.delete',
  auditRead: 'organization_settings.audit_trails.read',
  auditExport: 'organization_settings.audit_trails.export',
  appearanceRead: 'organization_settings.appearance.read',
  appearanceUpdate: 'organization_settings.appearance.update',
  orgStructureManage: 'organization_settings.org_structure.manage',
  notificationsRead: 'organization_settings.notifications.read',
  notificationsUpdate: 'organization_settings.notifications.update',
  recruitingJobDescriptionsView: 'recruiting.job_descriptions.view',
  recruitingJobDescriptionsCreate: 'recruiting.job_descriptions.create',
  recruitingJobDescriptionsEdit: 'recruiting.job_descriptions.edit',
  recruitingJobDescriptionsArchive: 'recruiting.job_descriptions.archive',
  recruitingPositionsView: 'recruiting.positions.view',
  recruitingPositionsOpen: 'recruiting.positions.open',
  recruitingPositionsEdit: 'recruiting.positions.edit',
  recruitingPositionsClose: 'recruiting.positions.close',
  recruitingCandidatesView: 'recruiting.candidates.view',
  recruitingCandidatesViewDetail: 'recruiting.candidates.view_detail',
  recruitingCandidatesViewReasoning: 'recruiting.candidates.view_reasoning',
  recruitingCandidatesReplyEmail: 'recruiting.candidates.reply_email',
  recruitingCandidatesDownloadResume: 'recruiting.candidates.download_resume',
  recruitingCandidatesArchive: 'recruiting.candidates.archive',
  recruitingCandidatesManageMailbox: 'recruiting.candidates.manage_mailbox',
  recruitingCandidatesSyncInbox: 'recruiting.candidates.sync_inbox',
  recruitingCandidatesDecide: 'recruiting.candidates.decide',
  meetingMeetingsView: 'meeting_agent.meetings.view',
  meetingMeetingsViewAll: 'meeting_agent.meetings.view_all',
  meetingEventsCreate: 'meeting_agent.events.create',
  meetingMeetingsShare: 'meeting_agent.meetings.share',
  meetingMeetingsDelete: 'meeting_agent.meetings.delete',
  meetingMeetingsRecord: 'meeting_agent.meetings.record',
  meetingIntelligenceView: 'meeting_agent.intelligence.view',
  meetingIntelligenceEdit: 'meeting_agent.intelligence.edit',
  meetingCalendarConnect: 'meeting_agent.calendar.connect',
  meetingChatSearch: 'meeting_agent.chat.search',
  meetingConnectorsManage: 'meeting_agent.connectors.manage',
  taskAccess: 'task_intelligence.access',
  taskTeamView: 'task_intelligence.team.view',
} as const;

export function hasPermission(granted: string[] | undefined, needed: string): boolean {
  const list = granted ?? [];
  if (list.includes('*') || list.includes(needed)) {
    return true;
  }
  return list.some((key) => key.endsWith('.*') && needed.startsWith(key.slice(0, -1)));
}

export function hasAnyOrgSettingsPermission(granted: string[] | undefined): boolean {
  return (granted ?? []).some((key) => key.startsWith('organization_settings.'));
}

export const SUPER_ADMIN_ROLE_NAME = 'Super Admin';

export function isSuperAdminRoleName(name?: string | null): boolean {
  return name?.trim().toLowerCase() === SUPER_ADMIN_ROLE_NAME.toLowerCase();
}
